<template>
  <v-card min-width="600">
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.ADD') }} {{ $t('DEVICES.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <customer-details v-if="person" class="pa-4 mb-4" :person="person" />

      <v-form ref="form" v-model="valid" lazy-validation>
        <attach-form
          v-model="form"
          :errors="errors.getAll()"
          @selected-device="setSelectedDevice"
          @update-prop="clearErrorByName($event)"
        />
      </v-form>

      <device-details v-if="device" class="pa-4 mb-4" :device="device" />
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>

      <v-spacer />

      <v-btn depressed color="primary" :disabled="!valid" @click="attach">
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { dateFormat } from '@/modules/_global/filters';
import { DevicesService } from '@/services/devices.service';
import { onceRequest } from '@/modules/_global/utils/common';
import AttachForm from '@/modules/devices/Device/components/forms/AttachForm.vue';
import CustomerDetails from '@/modules/devices/Device/components/CustomerDetails.vue';
import DeviceDetails from './DeviceDetails.vue';

export default {
  name: 'SelectDevice',

  components: {
    AttachForm,
    DeviceDetails,
    CustomerDetails
  },

  filters: {
    dateFormat
  },

  mixins: [errors],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: true,
      form: {},
      person: {},
      device: null
    };
  },

  mounted() {
    this.retrievePerson(this.personId).then(({ data }) => {
      this.person = data;
    });
  },

  methods: {
    ...mapActions('person', ['retrievePerson']),
    ...mapActions('snackbar', ['setSnack']),

    cancel() {
      this.$emit('cancel');
    },

    setSelectedDevice(device) {
      this.device = device;
    },

    attach: onceRequest(function attach() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const data = {
        person_id: this.personId,
        device_id: this.form.device_id
      };

      return DevicesService.attach(data)
        .then(({ data }) => {
          this.setSnack({
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });

          this.$emit('created', data.data);
        })
        .catch(this.handleErrors);
    })
  }
};
</script>
